import { useNavigate } from "react-router-dom";
import { MessageCircle, Sparkles, Database, Send, ArrowRight, Bot } from "lucide-react";
import { ChatWidget } from "@/components/ChatWidget";
import { useEffect, useState } from "react";
import { publicApi } from "@/lib/apiClient";

export default function Landing() {
  const navigate = useNavigate();
  const [demoId, setDemoId] = useState(null);

  useEffect(() => {
    publicApi.get(`/public/business/demo`).catch(() => {});
  }, []);

  const features = [
    { icon: Database, title: "Multi-Bisnis & Multi-Database", desc: "Kelola banyak bisnis sekaligus, masing-masing dengan database sendiri — MySQL, PostgreSQL, atau MongoDB, mendukung WooCommerce & tabel standar." },
    { icon: MessageCircle, title: "Chatbot Berbasis Produk", desc: "Chatbot menjawab pertanyaan pelanggan langsung dari data produk bisnis Anda, 24/7." },
    { icon: Sparkles, title: "Generate Konten AI", desc: "Buat caption Instagram, Facebook, TikTok & artikel blog otomatis dari data produk atau brief manual." },
    { icon: Send, title: "Notifikasi WhatsApp", desc: "Setiap lead baru langsung dikirim ke WhatsApp admin via Fonnte API." },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-900 grain relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#2563EB] opacity-10 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#10B981] opacity-10 blur-[140px] rounded-full pointer-events-none" />

      <nav className="relative z-10 flex flex-wrap items-center justify-between gap-3 px-4 sm:px-6 md:px-12 py-5 border-b border-[#E2E8F0]">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-[#2563EB] flex items-center justify-center">
            <Bot size={20} className="text-white" />
          </div>
          <span className="font-heading font-extrabold text-base sm:text-lg tracking-tight">ContentChat<span className="text-[#2563EB]">AI</span></span>
        </div>
        <button
          onClick={() => navigate("/admin")}
          data-testid="landing-admin-button"
          className="flex items-center gap-2 bg-white text-[#0F172A] font-semibold text-xs sm:text-sm px-3 sm:px-5 py-2.5 rounded-full hover:bg-slate-200 transition-colors"
        >
          Masuk Admin <ArrowRight size={16} />
        </button>
      </nav>

      <section className="relative z-10 max-w-5xl mx-auto px-6 pt-20 pb-24 text-left">
        <div className="inline-flex items-center gap-2 bg-[#FFFFFF] border border-[#E2E8F0] rounded-full px-4 py-1.5 mb-8 animate-fade-up">
          <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse" />
          <span className="text-xs font-mono-code text-slate-600 uppercase tracking-wider">AI Content & Chat Assistant</span>
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] mb-6 animate-fade-up" style={{ animationDelay: "0.1s" }}>
          Chatbot pintar &<br />
          <span className="text-[#2563EB]">generator konten</span> untuk<br />
          setiap bisnis Anda.
        </h1>
        <p className="text-slate-600 text-base sm:text-lg max-w-2xl mb-10 leading-relaxed animate-fade-up" style={{ animationDelay: "0.2s" }}>
          Hubungkan database produk, pasang widget chat di website, hasilkan konten siap posting, dan terima notifikasi lead via WhatsApp — semua dalam satu dashboard.
        </p>
        <div className="flex flex-wrap gap-4 animate-fade-up" style={{ animationDelay: "0.3s" }}>
          <button
            onClick={() => navigate("/admin")}
            className="flex items-center gap-2 bg-[#2563EB] text-white font-semibold px-7 py-3.5 rounded-full hover:bg-[#1D4ED8] transition-colors"
          >
            Mulai Sekarang <ArrowRight size={18} />
          </button>
        </div>
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-6 pb-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-6 hover:border-[#3B82F6] transition-colors animate-fade-up"
              style={{ animationDelay: `${0.1 * i}s` }}
            >
              <div className="w-11 h-11 rounded-xl bg-[#F1F5F9] flex items-center justify-center mb-4">
                <f.icon size={22} className="text-[#2563EB]" />
              </div>
              <h3 className="font-heading font-bold text-base mb-2">{f.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
